module.exports = __webpack_public_path__ + "media/Audio18_k.45e4f665.wav";